// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2355":"14c0de7efc3ac71c","6076":"e507e68056e9002e","9715":"6b1adb925a8f117d"}[chunkId] + ".css";
};